import {PresentationRubrique} from "../components/commons";
import { usePageTitle, useScrollToTop } from "../hooks";
import { useParams } from "react-router-dom";
import { menuItems } from "../data/rubriqueMenu.data"; // Assurez-vous que ce chemin est correct

const Rubrique = () => {
    const { id } = useParams();

    // Trouver la rubrique correspondante
    const foundRubrique = menuItems.find(
        item => item.label.toLowerCase().replace(/\s+/g, '_') === id
    );

    // Définir le titre de la page avec le nom de la rubrique
    const rubriqueTitle = foundRubrique ? foundRubrique.label : "Rubrique";
    usePageTitle(`${rubriqueTitle}`);
    useScrollToTop();

    return (
        <div>
            <PresentationRubrique />
        </div>
    );
}

export default Rubrique;